module.exports = __webpack_public_path__ + "static/img/smartstation12.093e3ff8.png";